import React, { useRef, useState } from 'react'
import styles from './CustomSliderPersona.module.css'
import thumbImg from '../../Assets/SliderBtnLarg.png'

const SLIDER_HEIGHT = 250
const THUMB_SIZE = 70
const THUMB_HALF = THUMB_SIZE / 2

const CustomSlider = (props) => {
    const { value, setValue } = props
    const logicTrackRef = useRef(null)
    const [dragging, setDragging] = useState(false)

    const percentage = mapYToNewValue(value) // 0 → 100

    function mapYToNewValue(y) {
        const inMin = 0
        const inMax = 100
        const outMin = -6
        const outMax = 106

        return outMin + ((y - inMin) * (outMax - outMin)) / (inMax - inMin)
    }

    console.log('MMMMMMMMMMM percentage', percentage)

    const updateValueFromY = (clientY) => {
        const rect = logicTrackRef.current.getBoundingClientRect()

        // Cursor relative to invisible track
        let y = clientY - rect.top
        // Clamp to logic track
        y = Math.max(0, Math.min(y, SLIDER_HEIGHT))

        const newValue = (y / SLIDER_HEIGHT) * 100

        setValue(Math.round(newValue))
    }

    const startDrag = (e) => {
        e.preventDefault()
        setDragging(true)
        updateValueFromY(e.clientY)
    }

    const onDrag = (e) => {
        if (!dragging) return
        updateValueFromY(e.clientY)
    }

    const stopDrag = () => setDragging(false)

    return (
        <div
            className={styles.wrapper}
            onMouseMove={onDrag}
            onMouseUp={stopDrag}
            onMouseLeave={stopDrag}
        >
            {/* Invisible logic track */}
            <div
                className={styles.logicTrack}
                ref={logicTrackRef}
                onMouseDown={startDrag}
            />

            {/* Visible UI */}
            <div className={styles.uiTrackWrapper}>
                <div
                    className={styles.uiTrack}
                    style={{
                        background: `
                      linear-gradient(to top, #e6e5e2, #f5bc47),
                     linear-gradient(to top, #e6e5e2, #c3c3c3)
                    `,
                        backgroundSize: `100% ${100 - value}%, 100% ${value}%`,
                        backgroundPosition: `bottom, top`,
                        backgroundRepeat: 'no-repeat',
                    }}
                >
                    <div
                        className={styles.thumb}
                        style={{
                            top: `${percentage}%`,
                            backgroundImage: `url(${thumbImg})`,
                            transform: 'translate(-50%, -50%)',
                        }}
                        onMouseDown={startDrag}
                    />
                </div>
            </div>

            {/* <p className={styles.value}>{value}</p> */}
        </div>
    )
}

export default CustomSlider
